import { Surviver } from '@/base/domains';

export class InMemorySurviver implements Surviver {
  live(): Promise<void> {
    return Promise.resolve();
  }
}
